/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCheckCallSchedLookup.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/check-call-sched-lookup";

export class AutogenModelCheckCallSchedLookup<RowType extends ModelRow> extends Endpoint<RowType, RowCheckCallSchedLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCheckCallSchedLookup extends ModelRow<RowCheckCallSchedLookupFields> {
	constructor(values?: Partial<RowCheckCallSchedLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCheckCallSchedLookupFields {
	commodity_id: string;
	company_id: string;
	customer_id: string;
	descr: string;
	equipment_type_id: string;
	id: string;
	message_type: string;
	resend_interval: number;
	resend_message: string;
	sched_type: string;
}

